<a href="javascript:;" class="collapsable-title" (click)="toggle()">{{ title }}</a>
<ng-content *ngIf="open"></ng-content>
